import { Pipe, PipeTransform } from '@angular/core';
import { Converter } from '@app/shared/utils/converter';

@Pipe({
  standalone: true,
  name: 'tiBytesConvert',
})
export class BytesConvert implements PipeTransform {
  transform(value: number): any {
    return Converter.Bytes.toString(value);
  }
}
